// extracted by mini-css-extract-plugin
export default {"container":"wW-z","title":"xW-z","link":"yW-z"};